export default __webpack_public_path__ + "static/media/miliy.aff52f5d.png";